
import { Component, Prop, Vue } from 'vue-property-decorator';

import Avatar from '@/components/Avatar/index.vue';

import { Teacher } from '../../interface';

@Component({
  components: {
    Avatar
  }
})
export default class ChatMessage extends Vue {
  @Prop() user!: Teacher;
  @Prop() isBgTransparent!: boolean;
  @Prop() active!: boolean;
}
